import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Smartphone, ShieldOff, Loader2 } from "lucide-react";

export default function SessionsPanel() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/sessions");
      setItems(data);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const revoke = async (id) => {
    setBusy(true);
    try {
      await api.post(`/sessions/${id}/revoke`);
      toast.success("Session revoked");
      load();
    } catch { toast.error("Failed"); }
    setBusy(false);
  };

  return (
    <div className="space-y-2" data-testid="sessions-panel">
      <p className="text-xs text-muted-foreground">Sign-in history for this account. Revoke any device you don&apos;t recognize.</p>
      <div className="space-y-2">
        {items.map((s) => (
          <div key={s.id} className="flex items-center gap-3 border border-border rounded-lg p-2.5" data-testid={`session-${s.id}`}>
            <div className="h-8 w-8 rounded-md bg-emerald-brand/10 text-emerald-brand grid place-items-center">
              <Smartphone className="h-3.5 w-3.5" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-xs font-mono truncate">{s.user_agent || "unknown device"}</div>
              <div className="text-[10px] text-muted-foreground font-mono">IP {s.ip || "—"} · started {(s.created_at || "").slice(0, 16).replace("T", " ")}</div>
            </div>
            {!s.revoked ? (
              <Button variant="outline" size="sm" onClick={() => revoke(s.id)} disabled={busy} className="rounded-lg" data-testid={`revoke-${s.id}`}>
                {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><ShieldOff className="h-3.5 w-3.5 mr-1" />Revoke</>}
              </Button>
            ) : (
              <span className="pill bg-muted text-muted-foreground text-[10px] font-mono">revoked</span>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-xs text-muted-foreground py-4">No sessions.</div>}
      </div>
    </div>
  );
}
